import { render, staticRenderFns } from "./FormFieldsDetails.vue?vue&type=template&id=5b561ac3&"
import script from "./FormFieldsDetails.vue?vue&type=script&lang=js&"
export * from "./FormFieldsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports